import { getCatalog } from '../../../api/movies/index';
import { store } from '../../../utils/globalData';
import { checkImage } from '../../../utils/helpers';
import VODComponent from '../../Home/components/VODComponent';
import { Row } from '@lightningjs/ui-components';

const mapMovie = (movies, id, index) => {
  const movie = Object.values(movies).find((movie) => movie.id === id);

  if (!movie) {
    console.error(`Movie with id ${id} not found`);
    return null; // Handle the case when movie is not found
  }
  return {
    collision: true,
    type: VODComponent,
    index,
    src: checkImage(
      movie?.alternative_covers,
      movie?.['cover_art.expiring_url'] ?? 'default_image.png'
    ), // Use optional chaining and default value
    isLocked: movie.tvod ?? false,
    isProtected: movie?.locked ?? false,
    w: 204,
    h: 290,
    data: {
      originalImage: movie?.['cover_art.expiring_url'] ?? 'default_image.png', // Default image if undefined
      kind: movie?.kind ?? 'Unknown', // Default value if undefined
      id: movie?.id ?? 'Unknown', // Default value if undefined
      title: movie?.name ?? 'No Title', // Default title if undefined
      description: movie?.description ?? 'No Description Available', // Default description if undefined
      cover: movie?.['screenshot.expiring_url'] ?? 'default_cover.png', // Default cover if undefined
      category: movie?.tags ?? [], // Default value if tags are undefined
      duration: movie?.duration ?? '0', // Default duration if undefined
      rating: movie?.imdb?.rating === null ? '−' : movie?.imdb?.rating?.avg ?? '−', // Handle null and undefined ratings
      votes: movie?.imdb?.rating === null ? '−' : movie?.imdb?.rating?.num_votes ?? '−', // Handle null and undefined votes
      contentRating: movie?.content_rating ?? 'Not Rated', // Default content rating if undefined
    },
  };
};

const mapSeries = (series, id, index) => {
  const serie = Object.values(series).find((serie) => serie.id === id);

  if (!serie) {
    console.error(`Series with id ${id} not found`);
    return null; // Handle the case when the series is not found
  }

  return {
    collision: true,
    type: VODComponent,
    index,
    src: checkImage(
      serie?.alternative_covers,
      serie?.['cover_art.expiring_url'] ?? 'default_image.png'
    ), // Use optional chaining and default value
    isProtected: false,
    w: 204,
    h: 290,
    data: {
      originalImage: serie?.['cover_art.expiring_url'] ?? 'default_image.png', // Default image if undefined
      kind: serie?.kind ?? 'Unknown', // Default value if undefined
      id: serie?.id ?? 'Unknown', // Default value if undefined
      title: serie?.name ?? 'No Title', // Default title if undefined
      description: serie?.description ?? 'No Description Available', // Default description if undefined
      cover: serie?.['screenshot.expiring_url'] ?? 'default_cover.png', // Default cover if undefined
      category: serie?.tags ?? [], // Default value if tags are undefined
      duration: serie?.duration ?? '0', // Default duration if undefined
      rating: serie?.imdb?.rating === null ? '−' : serie?.imdb?.rating?.avg ?? '−', // Handle null and undefined ratings
      votes: serie?.imdb?.rating === null ? '−' : serie?.imdb?.rating?.num_votes ?? '−', // Handle null and undefined votes
      contentRating: serie?.content_rating ?? 'Not Rated', // Default content rating if undefined
    },
  };
};

const ROW_SIZE = 6;
export default async function (page) {
  let data = store.getData();
  let myList = store.getMyListFlag();
  if (!data || !myList) {
    console.log('Nema u store, preuzimam podatke...');
    const catalogData = await getCatalog();
    data = catalogData.data;
    store.setData(data);
    store.setMyListFlag(true);
  } else {
    console.log('Podaci su već u store');
  }
  const rows = data.data.root_index;
  const categories = data.index;
  const pageItems = [];
  let dataa;
  let title;
  let myListItems = []; // Initialize myListItems as an empty array

  let isFirstRow = true; // Keep track of whether we're processing the first row

  rows.forEach((row) => {
    const category = Object.values(categories[row.kind]).find(
      (category) => category.id === row.id && category.id === 3 && category.kind == 'dynamic_series'
    );
    if (category) {
      dataa = category;
      const isCollectionRow = !category?.items?.some((item) => item.kind !== 'collection');
      title = isFirstRow ? 'My List' : ''; // Show "My List" for the first row only
      isFirstRow = false; // Mark that we've processed the first row

      const items = category?.items
        .map((item, index) => {
          // Calculate VOD index in a row of 6 items, resetting it for each new row
          const vodIndex = index % ROW_SIZE;

          let mappedItem;
          switch (item.kind) {
            case 'movie':
              mappedItem = mapMovie(categories.movies, item.id, vodIndex);
              break;
            case 'subseries':
              mappedItem = mapSeries(categories.subseries, item.id, vodIndex);
              break;
            default:
              mappedItem = null;
          }

          if (mappedItem) {
            // Add rowIndex to the mapped item
            mappedItem.rowIndex = Math.floor(index / ROW_SIZE); // Calculate row index
          }
          return mappedItem;
        })
        .filter((pageItem) => Boolean(pageItem));

      // Introduce rowIndex and increment it with each row
      let rowIndex = 0;

      // Divide items into subarrays of 6 items each
      for (let i = 0; i < items.length; i += ROW_SIZE) {
        pageItems.push({
          collision: true,
          type: Row,
          title: i === 0 ? title : '', // Show "My List" only for the first item in each row
          h: 320,
          items: items.slice(i, i + ROW_SIZE).map((item, idx) => {
            // Reset the index from 0 to 5 within each new row
            item.index = idx;
            item.rowIndex = rowIndex; // Set rowIndex for each row
            return item;
          }),

          style: {
            itemSpacing: 50,
          },
        });

        rowIndex++; // Increment rowIndex for each new row
      }

      // Add the items from this row to myListItems
      myListItems = myListItems.concat(items);
    }
  });

  page.myListTitle = title;
  page._Column.items = pageItems ?? [];
  page.data = dataa;
}
